import React from 'react';
import Icon from '../../../components/AppIcon';

const ActiveEditorsPanel = ({ activeEditors = [], currentUserEmail }) => {
  // Filter out current user from the list
  const otherEditors = activeEditors?.filter(editor => editor?.user_email !== currentUserEmail);

  if (otherEditors?.length === 0) {
    return null;
  }

  const getTimeAgo = (lastSeen) => {
    if (!lastSeen) return 'just now';
    
    const now = new Date();
    const seenDate = new Date(lastSeen);
    const diffMs = now - seenDate;
    const diffSecs = Math.floor(diffMs / 1000);
    const diffMins = Math.floor(diffSecs / 60);

    if (diffSecs < 10) return 'just now';
    if (diffSecs < 60) return `${diffSecs}s ago`;
    if (diffMins < 60) return `${diffMins}m ago`;
    return 'inactive';
  };

  return (
    <div className="fixed top-20 right-4 bg-white rounded-lg shadow-lg border border-gray-200 p-3 z-50 min-w-[200px]">
      <div className="flex items-center gap-2 mb-2 pb-2 border-b border-gray-200">
        <Icon name="Users" className="w-4 h-4 text-gray-600" />
        <span className="text-sm font-medium text-gray-700">Active Editors</span>
      </div>
      
      <div className="space-y-2">
        {otherEditors?.map((editor, index) => (
          <div key={index} className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
            <div className="flex-1">
              <div className="text-xs font-medium text-gray-700 truncate">
                {editor?.user_email?.split('@')?.[0]}
              </div>
              <div className="text-xs text-gray-500">
                {getTimeAgo(editor?.last_seen)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActiveEditorsPanel;